import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { FileText } from 'lucide-react';

export default function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <main className="pt-32 pb-24">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 rounded-full border border-white/10 mb-6">
              <FileText className="w-4 h-4 text-emerald-400" />
              <span className="text-white/60 text-sm">Legal</span>
            </div>
            <h1 className="text-4xl sm:text-5xl font-bold text-white" data-testid="terms-heading">Terms of Service</h1>
            <p className="text-white/40 text-sm mt-4">Last updated: January 2025</p>
          </div>

          <div className="space-y-8" data-testid="terms-content">
            <Section title="Acceptance of Terms">
              By accessing and using the Frontier Investments website ("the Website"), you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, please do not use the Website. These terms apply to all visitors, users and clients of the Website.
            </Section>

            <Section title="Nature of Services">
              Frontier Investments is not a SEBI registered entity. We are AMFI certified Mutual Fund Distributors (ARN-92591). The content on this Website is intended for informational and educational purposes only and should not be construed as personalised investment advice. All investment decisions should be made after consulting with a qualified financial advisor and considering your individual financial circumstances, risk tolerance and investment objectives.
            </Section>

            <Section title="No Guarantee of Returns">
              Mutual fund investments and all capital market instruments are subject to market risks. Past performance is not indicative of future results. We do not guarantee or assure any specific returns, dividends or investment outcomes. The NAVs of mutual fund schemes may fluctuate based on market conditions, interest rate movements and other economic factors.
            </Section>

            <Section title="Use of Calculators and Tools">
              The financial calculators, tools and projections available on this Website are provided solely for illustrative and educational purposes. The results generated are based on assumed rates of return and may not reflect actual market conditions. Users should not rely on these tools as the sole basis for making investment decisions. Please consult your advisor for personalised guidance.
            </Section>

            <Section title="Portfolio Review Service">
              When you submit documents or information through our Portfolio Review feature, you consent to our team reviewing the submitted materials for the purpose of providing an assessment. All uploaded documents are handled in accordance with our Privacy Policy. We reserve the right to decline any portfolio review request at our discretion.
            </Section>

            <Section title="Intellectual Property">
              All content on this Website, including text, graphics, logos, images, and software, is the property of Frontier Investments or its content suppliers and is protected by applicable intellectual property laws. You may not reproduce, distribute or create derivative works from any content on this Website without prior written consent.
            </Section>

            <Section title="User Conduct">
              You agree to use the Website only for lawful purposes and in a manner that does not infringe upon the rights of others. You shall not upload any malicious content, attempt to gain unauthorised access to our systems, or use the Website in any way that could damage, disable or impair its functionality.
            </Section>

            <Section title="Limitation of Liability">
              To the fullest extent permitted by law, Frontier Investments shall not be liable for any direct, indirect, incidental, consequential or punitive damages arising out of your use of the Website or reliance on any information provided herein. This includes, without limitation, any losses arising from investment decisions made based on information available on this Website.
            </Section>

            <Section title="Third-Party Links">
              The Website may contain links to third-party websites or resources. We do not endorse and are not responsible for the content, accuracy or practices of any third-party websites. Accessing such links is at your own risk.
            </Section>

            <Section title="Modifications to Terms">
              We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting on this page. Your continued use of the Website following any modifications constitutes acceptance of the revised terms.
            </Section>

            <Section title="Governing Law">
              These Terms of Service shall be governed by and construed in accordance with the laws of India. Any disputes arising from the use of this Website shall be subject to the exclusive jurisdiction of the courts in Bangalore, India.
            </Section>

            <Section title="Contact Us">
              For any questions regarding these Terms of Service, please contact us at contact@frontierinvestments.co or call us at +91 93532 80305.
            </Section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div className="bg-white/5 rounded-2xl border border-white/10 p-6 lg:p-8">
      <h2 className="text-lg font-bold text-white mb-3">{title}</h2>
      <p className="text-white/60 text-sm leading-relaxed">{children}</p>
    </div>
  );
}
